<ul class="sensitive-data flex gap-2" *transloco="let t">
  @if (selectedAccountGroup(); as selectedAccountGroup) {
    <div class="flex items-center gap-2">
      <app-account-group-selector
        [selectedAccountGroupId]="selectedAccountGroup.id"
        (accountGroupChange)="selectGroup($event)"
      />

      @if (selectedMarketplacesMap().size > 0) {
        <app-marketplace-selector
          [marketplaces]="marketplaces()"
          [selectedMarketplace]="selectedMarketplace()"
          (marketplaceChange)="selectMarketplace($event)"
        />
      }
      @if (scope === "dashboard" && isReadOnly()) {
        <IBadge
          [tooltipValue]="t('account-selector.read_only_mode')"
          color="gray"
          size="xs"
          icon="eye"
          [label]="t('account-selector.read_only')"
          class="ml-2"
        />
      }
    </div>
  }
</ul>
